var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCongratulationBg = function SvgCongratulationBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 1536 1486",
    role: "presentation"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#497C54",
    strokeWidth: 80,
    d: "M1045 747c0 146.203-122.962 267-277.5 267S490 893.203 490 747s122.962-267 277.5-267S1045 600.797 1045 747Z",
    opacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#497C54",
    strokeWidth: 80,
    d: "M1265.15 746.5c0 263.58-221.28 479.5-497.075 479.5C492.283 1226 271 1010.08 271 746.5 271 482.923 492.283 267 768.075 267c275.795 0 497.075 215.923 497.075 479.5Z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#497C54",
    strokeWidth: 80,
    d: "M1496 743c0 387.02-324.68 703-728 703-403.321 0-728-315.98-728-703S364.679 40 768 40c403.32 0 728 315.981 728 703Z",
    opacity: 0.2
  })));
};
export default SvgCongratulationBg;